import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    searchInputLabel: 'Look for your client',
    searchInputPlaceholder: 'Name, SIREN or SIRET',
  },
  fr: {
    searchInputLabel: 'Recherchez votre client',
    searchInputPlaceholder: 'Nom, SIREN ou SIRET',
  },
} as const);

export default locales;
